import { render, staticRenderFns } from "./AppHeaderBackWithTitle.vue?vue&type=template&id=71321600&scoped=true&"
import script from "./AppHeaderBackWithTitle.vue?vue&type=script&lang=ts&"
export * from "./AppHeaderBackWithTitle.vue?vue&type=script&lang=ts&"
import style0 from "./AppHeaderBackWithTitle.vue?vue&type=style&index=0&id=71321600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71321600",
  null
  
)

/* custom blocks */
import block0 from "./AppHeaderBackWithTitle.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports